import { useContext } from 'react';
import AppContext from '../../../AppContext';
import RatioFormat from '../../format/RatioFormat';
import DollarFormat from '../../format/DollarFormat';
import DecimalFormat from '../../format/DecimalFormat';
import AnnualChangeRowProps from './AnnualChangeRowProps';
import { DataResult } from '../../model/DataResult';
import { renderYearValueAsDollar } from './yearRenderUtils';

export default function AmountRow({
  data,
  showPercentPointChange,
  showDollarChange
}: AnnualChangeRowProps) {
  const { activeYearsMode } = useContext(AppContext);
  const showTenYearCells = activeYearsMode === 'TEN' && data.priorYearMinusFour !== undefined;
  function getOtherRatioCell(
    phsData: DataResult,
    casData: DataResult,
    tdpData: DataResult,
    pcData: DataResult,
    currentYearIsNA: boolean
  ) {
    if (currentYearIsNA) {
      return <p></p>;
    }
    if (phsData && phsData.value !== null) {
      return <RatioFormat {...phsData}></RatioFormat>;
    } else if (casData && casData.value !== null) {
      return <RatioFormat {...casData}></RatioFormat>;
    } else if (pcData && pcData.value !== null) {
      return <RatioFormat {...pcData}></RatioFormat>;
    } else {
      return <RatioFormat {...tdpData}></RatioFormat>;
    }
  }

  const currentYearIsNA = data.currentYear?.showAsNA === true;

  return (
    <>
      {showPercentPointChange ? (
        <RatioFormat {...data.percentOrPointChange} showDefaultValue={true} />
      ) : (
        <p></p>
      )}

      {showDollarChange ? <DollarFormat {...data.dollarChange} showDefaultValue={true} /> : <p></p>}

      {getOtherRatioCell(
        data.percentOfPHS,
        data.percentOfCAS,
        data.percentOfTDP,
        data.percentOfCurrentYear,
        currentYearIsNA
      )}
      {currentYearIsNA ? <p></p> : <RatioFormat {...data.percentOfNAA} />}
      <DecimalFormat {...data.industryMean} />
      {renderYearValueAsDollar(data.currentYear)}
      {renderYearValueAsDollar(data.priorYear)}
      {renderYearValueAsDollar(data.priorYearMinusOne)}
      {renderYearValueAsDollar(data.priorYearMinusTwo)}
      {renderYearValueAsDollar(data.priorYearMinusThree)}
      {showTenYearCells && (
        <>
          {renderYearValueAsDollar(data.priorYearMinusFour as DataResult)}
          {renderYearValueAsDollar(data.priorYearMinusFive as DataResult)}
          {renderYearValueAsDollar(data.priorYearMinusSix as DataResult)}
          {renderYearValueAsDollar(data.priorYearMinusSeven as DataResult)}
          {renderYearValueAsDollar(data.priorYearMinusEight as DataResult)}
        </>
      )}
    </>
  );
}
